const WORDS = [
    "PINO NACIONAL",
    "HERRAJES PREMIUM",
    "PRODUCCIÓN VENEZOLANA",
    "DETAL & MAYOREO",
    "TODO PARA EL CARPINTERO",
    "ENVÍO A TODO EL PAÍS",
];

export const BrandMarquee = () => {
    const line = [...WORDS, ...WORDS];
    return (
        <div className="overflow-hidden py-4 hero-gradient">
            <div className="marquee-track">
                {line.map((w, i) => (
                    <span key={i} className="text-sm uppercase tracking-[0.25em] mx-8 text-white/80 font-medium">
                        {w} <span className="text-madera mx-3">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
